import React, { useContext, useMemo } from 'react';

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  Button
} from 'reactstrap';

import Select from 'react-select';

import FieldError from '../../../../../../helper/FieldError';

import WorkflowDiagramContext from '../../../../../diagram_context';

const WorkflowHttpRequestBodyRequestContentItemForm = props => {
  const {
    currentNode,
    bodyRequestContentItem,
    callbacks: {
      onChangeBodyRequestContentItem: callbackOnChangeBodyRequestContentItem,
      onRemoveBodyRequestContentItem: callbackOnRemoveBodyRequestContentItem,
      activeInputStageFileItems
    } = {}
  } = props;

  const {
    workflowProcess,
    callbacks: {
      prevStages
    }
  } = useContext(WorkflowDiagramContext);

  const errorKey = (key) => {
    return `data.errors.body_request_content_${bodyRequestContentItem.custom_id}_${key}`
  }

  // ---------- START KEY INPUT ----------
  const keyInput = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, errorKey('key')) }>
          <Label className='required'>
            Key
          </Label>
          <Input
            type="text"
            name="key"
            value={ bodyRequestContentItem?.key || '' }
            invalid={ _.has(currentNode, errorKey('key')) }
            onChange={ event => callbackOnChangeBodyRequestContentItem(event, bodyRequestContentItem.custom_id) }
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END KEY INPUT ----------
  // ----------------------------------------
  // ---------- START VALUE INPUT SELECT ----------

  const prevStageSelectOptionsGrouped = useMemo(() => {
    let options = [];

    _.each(prevStages(currentNode), (prevStage) => {
      let group = {
        label: prevStage?.data?.label,
        options: []
      }

      _.each(prevStage?.data?.output_stage_form?.field_items, (fieldItem) => {
        const value = `$prev_stage-${ prevStage?.data?.id }.output_field_item-${ fieldItem?.custom_id }$`;

        group.options.push({
          label: fieldItem.name,
          value: value
        })
      })

      options.push(group)
    })

    return options;
  }, [prevStages(currentNode)])

  const processSelectOptionsGrouped = useMemo(() => {
    let group = {
      label: 'Proceso',
      options: []
    }

    if(workflowProcess.require_custom_identifier) {
      group.options.push({
        label: I18n.t('activerecord.attributes.workflow/requirement.identifier'),
        value: '$requirement.identifier$'
      })
    }

    return group;
  }, [workflowProcess])

  const currentStageSelectOptionsGrouped = useMemo(() => {
    let group = {
      label: currentNode?.data?.label,
      options: []
    }

    _.each(activeInputStageFileItems, (fileItem) => {
      group.options.push({
        label: fileItem.name,
        value: `$current_stage-${ currentNode?.data?.id }.input_file_item-${ fileItem?.custom_id }$`
      })
    })

    return group
  }, [activeInputStageFileItems])

  const valueInputSelectOptionsGrouped = useMemo(() => {
    return [currentStageSelectOptionsGrouped, processSelectOptionsGrouped, ...prevStageSelectOptionsGrouped ]
  }, [prevStageSelectOptionsGrouped, currentStageSelectOptionsGrouped, processSelectOptionsGrouped])

  const valueInputSelectedOption = useMemo(() => {
    let options = _.map(valueInputSelectOptionsGrouped, 'options');
    options = _.flatten(options);

    return _.find(options, option => option.value === bodyRequestContentItem?.value)
  }, [bodyRequestContentItem?.value, valueInputSelectOptionsGrouped])

  const valueInputSelect = () => {
    return(
      <FormGroup>
        <FieldError errors={ _.get(currentNode, errorKey('value')) }>
          <Label>Value</Label>
          <Select
            options={ valueInputSelectOptionsGrouped }
            value={ valueInputSelectedOption }
            onChange={ event => callbackOnChangeBodyRequestContentItem({ target: { name: 'value', value: event.value } }, bodyRequestContentItem.custom_id) }
            invalid={ _.has(currentNode, errorKey('value')) }
          />
        </FieldError>
      </FormGroup>
    )
  }
  // ---------- END VALUE INPUT SELECT ----------
  // ----------------------------------------
  // callbackOnRemoveBodyRequestContentItem
  // ---------- START REMOVE BUTTON ----------
  const removeButton = () => {
    return(
      <div className='text-end'>
        <Button
          outline
          color='danger'
          size='sm'
          onClick={ () => callbackOnRemoveBodyRequestContentItem(bodyRequestContentItem.custom_id) }
        >
          <i className='fas fa-trash'></i>&nbsp;
          { I18n.t('actions.destroy') }
        </Button>
      </div>
    )
  }
  // ---------- END REMOVE BUTTON ----------


  return(
    <Row>
      <Col md={ 12 }>
        <Card>
          <CardBody>
            <FieldError errors={ _.get(currentNode, 'data.errors.body_request_content') }/>
            { keyInput() }
            { valueInputSelect() }
            { removeButton() }
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default WorkflowHttpRequestBodyRequestContentItemForm;
